module.exports = __webpack_public_path__ + "static/media/addEvidenceButton.7aac9bfa.png";